import ErrorScreen from './ErrorScreen';
export default function NotFound() { return <ErrorScreen notFound />; }
